import React from "react";

interface ErrorMessageProps {
  message?: string;
}

const InputErrorMessage: React.FC<ErrorMessageProps> = ({ message }) => {
  if (!message) return null;

  return <span style={{ color: "red" }}>{message}</span>;
};

export default InputErrorMessage;
